import { CollingActionProps, UserInfo, ZaloConfigType } from 'interfaces/types'

export type NotificationType = {
  id: number | string
  message: string
  title?: string
  icon?: string
  image?: string
  meta?: {
    actionUrl?: string
    campaignId?: string
    siteName?: string
    email?: string
    token?: string
  }
}

export type State = {
  isLoggedIn: boolean
  isMobileSsr: boolean
  authorizing: boolean
  userInfo?: UserInfo | null
  openLogoutPopup: boolean
  newBookmark: number[]
  focusCommentId?: string | number
  isOpenDueDatePopup?: boolean
  dueDateRedirectLink?: string | null
  dueDate?: string | null
  currentDomain: string
  articlePlayingId: number
  showConfirmLeavePagePopup: string | null
  chatwootWebsiteToken: string
  zaloConfig: ZaloConfigType | null
  showFooter: boolean
  collectingAction: CollingActionProps[]
  healthInfo?: any
  cartNumber: number
  communityJoined: number[]
}

export type Action = {
  type: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload?: any
}

export type Context = {
  state: State
  dispatch: (action: Action) => void
}

export type TypeLoadingVaccination = 'delete' | 'switch-profile' | ''
export enum PhoneVerifyType {
  SMS = 'phone-sms',
  WHATSAPP = 'whatsapp',
}

export type LocationType = {
  longitude: number | string
  latitude: number | string
}
